module.exports = __webpack_public_path__ + "img/logo-doktortakvimi-turquoise-rgb.c50117c8.png";